import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const TopNav: StyleRule = () => ({
    alignItems: 'center',
    margin: pxArrayToRem([0, 6]),
});

export const BreadCrumb: StyleRule = () => ({
    marginTop: pxToRem(19),
    marginBottom: pxToRem(16),
});
